import React from "react";

const Annotation = ({ color }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    // >
    //   <g id="call_received_24px">
    //     <path
    //       id="icon/communication/call_received_24px"
    //       d="M19.5 5.91L18.09 4.5L6.5 16.09V9.5H4.5V19.5H14.5V17.5H7.91L19.5 5.91Z"
    //       fill={color}
    //       fillOpacity="1"
    //     />
    //   </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15 1.41L13.59 0L2 11.59V5H0V15H10V13H3.41L15 1.41Z"
        fill={color}
      />
    </svg>
  );
};

export default Annotation;
